import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { SIDEBAR_ACTIONS } from '../../../../../constants/actionsConstants';
import RightModalLayout from '../../../../layouts/Modal/RightModalLayout';
import MiaRetailerModel from '../../../../models/MiaRetailerModel';
import showtoast from '../../../../../util/toast';

const csrfToken = document.querySelector('[name=csrf-token]')?.content;

const Label = styled.span`
  font-family: 'Poppins-SemiBold';
  font-weight: 600;
  font-size: 14px;
  color: #23292E;
`;

const Description = styled.span`
  font-weight: 400;
  font-size: 12px;
  color: #23292E;
`;

const WhatsappConsolidationModal = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('ChatbotIA');

  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    MiaRetailerModel.get()
      .then((response) => {
        setEnabled(Boolean(response?.whatsapp_message_consolidation));
      })
      .catch((err) => {
        showtoast(err.error || t('config.error_loading'));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [t]);

  const handleClose = useCallback(() => {
    dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });
  }, [dispatch]);

  const handleSave = () => {
    setSaving(true);

    MiaRetailerModel.update(
      { whatsapp_message_consolidation: enabled },
      csrfToken
    )
      .then(() => {
        showtoast(t('config.save_success'));
        setSaving(false);
        handleClose();
      })
      .catch((err) => {
        setSaving(false);
        showtoast(err.message || err.error || t('config.save_error'));
      });
  };

  if (loading) {
    return (
      <RightModalLayout title={t('config.whatsapp_consolidation.title')} closeAction={handleClose}>
        <div className="tw-flex tw-justify-center tw-items-center tw-h-64">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">{t('config.loading')}</span>
          </div>
        </div>
      </RightModalLayout>
    );
  }

  return (
    <RightModalLayout
      title={t('config.whatsapp_consolidation.title')}
      closeAction={handleClose}
      submitLabel={t('guides.sidebar_create.update')}
      submitAction={handleSave}
      cancelLabel={t('buttonTexts.cancel')}
      cancelAction={handleClose}
      submitDisabled={saving}
    >
      <div>
        <div className="tw-flex tw-items-center tw-gap-3 tw-mb-2">
          <label className="switch tw-mb-0 tw-flex-shrink-0" style={{ top: 0 }}>
            <input
              type="checkbox"
              checked={enabled}
              onChange={(e) => setEnabled(e.target.checked)}
            />
            <span className="slider round" />
          </label>
          <Label>{t('config.whatsapp_consolidation.enableLabel')}</Label>
        </div>

        <Description className="tw-mb-4 tw-block">
          {t('config.whatsapp_consolidation.description')}
        </Description>

        <Description className="tw-block tw-text-gray-500">
          {enabled
            ? t('config.whatsapp_consolidation.on_note')
            : t('config.whatsapp_consolidation.off_note')}
        </Description>
      </div>
    </RightModalLayout>
  );
};

export default WhatsappConsolidationModal;
